/**
 * Tracks with matomo's _paq inserted with cookie first
 * @param {Array} data matomo data array
 * @returns {void}
 * * */
export default data => {
  console.log('track called with', data);
  if (typeof window === 'undefined') return;

  var _paq = (window._paq = window._paq || []);
  _paq.push(data);
};
